var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Self-Development Lab"),React.createElement("desc",{"key":1},"Created by Tricia Andor"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","fontFamily":"DeHangster-Regular, DeHangster","fontSize":"24","fontWeight":"normal","key":2},React.createElement("text",{"id":"Self-Development-Lab","fill":"#FFFFFF"},React.createElement("tspan",{"x":"1.836","y":"28"},"Self-Development Lab")))]);
}

Logo.defaultProps = {"width":"237px","height":"40px","viewBox":"0 0 237 40","version":"1.1"};

module.exports = Logo;

Logo.default = Logo;
